<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="loading" />
    <div v-html="privacyPolicy"></div>
  </div>
</template>

<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { settingsRepo } from "@/di/repositories";

const { data: privacyPolicy, isPending: loading } = useQuery({
  queryKey: ["settings", "privacy-policy"],
  queryFn: () => settingsRepo.getPrivacyPolicy(),
  staleTime: Infinity,
});
</script>

<style scoped></style>
